export const GET_USER_PROFILE = "GET_USER_PROFILE";
export const PAYMENT_MSG = "PAYMENT_MSG";
export const IS_LOGIN = "IS_LOGIN";
export const IS_SIGNUP = "IS_SIGNUP";
export const FETCH_PLAN_DETAILS = "FETCH_PLAN_DETAILS";
export const FETCH_PLAN_DETAILS_SUCCESS = "FETCH_PLAN_DETAILS_SUCCESS";
export const FETCH_PLAN_DETAILS_FAILURE = "FETCH_PLAN_DETAILS_FAILURE";
